module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-usage/arrow1-565e9c5a48625aff16b19d0628bf06e9.svg";